import { BUSINESS } from "../../../mocks/businessData";

const ITEMS = [
  { icon: "ri-star-fill",       text: `${BUSINESS.reviewCount} Five-Star Google Reviews` },
  { icon: "ri-shield-check-fill", text: "Fully Insured & Bonded" },
  { icon: "ri-time-fill",       text: "Open 24 / 7 — Emergency Service Available" },
  { icon: "ri-truck-fill",      text: "Free Pickup & Delivery — No Trip Charge" },
  { icon: "ri-leaf-fill",       text: "Child & Pet-Safe Eco-Friendly Chemicals" },
  { icon: "ri-award-fill",      text: "40+ Years of Expert Craftsmanship" },
  { icon: "ri-phone-fill",      text: BUSINESS.phone },
  { icon: "ri-map-pin-fill",    text: "Serving NJ · NY · PA · CT" },
];

const DOUBLE = [...ITEMS, ...ITEMS];

export default function TrustBar() {
  return (
    <div className="bg-stone-900 border-b border-stone-800 py-3.5 overflow-hidden select-none">
      <div className="flex marquee-track whitespace-nowrap">
        {DOUBLE.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-2 mx-8 flex-shrink-0">
            <span className="w-4 h-4 inline-flex items-center justify-center">
              <i className={`${item.icon} text-amber-500 text-xs`} />
            </span>
            <span className="text-stone-300 text-xs tracking-wide font-medium">{item.text}</span>
            <span className="text-stone-600 ml-6">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
